import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import DashboardContext from './context';
import { SectionContainer, SectionTitle } from '../common/styles';
import Total from './account-insights-components/total';
import GranularityToggle from '../common/charts/granularity-toggle';
import TypedUnitTooltip from './account-insights-components/typed-unit-tooltip';
import ColumnChart from '../common/charts/column-chart';
import ColumnChartNav from '../common/charts/column-chart-nav';
import {
  earliestStatsUnit, wiresToTotal, wiresToBucket,
} from './account-insights-components/transform';

const Header = styled.div`
  display: flex;
  width: 100%;
`;

export default function AccountInsights() {
  const {
    state: {
      wires, previousPeriodWires, daysAgo, granularity,
    },
    dispatch,
  } = React.useContext(DashboardContext);
  const [activeTile, setActiveTile] = React.useState('views');
  const [bucket, setBucket] = React.useState([]);
  const initialRange = { start: Math.min(daysAgo, 30), end: 0 };
  const [dateRange, setDateRange] = React.useState({ ...initialRange });
  const [visibleRange, setVisibleRange] = React.useState({ ...initialRange });

  React.useEffect(() => {
    let days = daysAgo;
    if (!Number.isFinite(daysAgo)) {
      days = earliestStatsUnit({ wires, granularity });
    }
    setDateRange({ start: days, end: 0 });
    const vRange = {
      start: Number.isFinite(daysAgo) ? Math.min(30, days) : 30,
      end: 0,
    };
    setVisibleRange(vRange);
  }, [wires, granularity, daysAgo]);

  React.useEffect(() => {
    setBucket(wiresToBucket({
      ...visibleRange,
      wires,
      granularity,
      key: activeTile,
    }));
  }, [wires, visibleRange, activeTile, granularity]);

  const buildClickHandler = key => () => {
    setActiveTile(key);
  };

  const items = ['views', 'engagements', 'likes', 'ctaClicks', 'enquiries'].map(key => ({
    type: _.lowerCase(key), // so that we have the space
    number: wiresToTotal(wires, key),
    previousPeriodNumber: Number.isFinite(daysAgo)
      ? wiresToTotal(previousPeriodWires, key)
      : Number.NaN,
    active: activeTile === key,
    onClick: buildClickHandler(key),
    clickable: true,
  }));

  const navProps = {
    granularity,
    visibleRange,
    range: dateRange,
    onPrev: () => {
      setVisibleRange({ start: visibleRange.start + 30, end: visibleRange.end + 30 });
    },
    onNext: () => {
      setVisibleRange({ start: visibleRange.start - 30, end: visibleRange.end - 30 });
    },
  };

  const chartProps = {
    bucket,
    granularity,
    type: _.lowerCase(activeTile),
    tooltipValueContent: TypedUnitTooltip,
  };

  const gProps = {
    daysAgo,
    granularity,
    onChange: g => dispatch({ type: 'setGranularity', payload: g }),
  };

  return (
    <SectionContainer>
      <SectionTitle>
        account insights
      </SectionTitle>
      <Header>
        {items.map(i => <Total {...i} key={i.type} />)}
      </Header>
      <GranularityToggle {...gProps} />
      <ColumnChart {...chartProps} />
      <ColumnChartNav {...navProps} />
    </SectionContainer>
  );
}
